import { useMemo } from 'react';
import { useCookie } from '../../../hooks/use-cookie-value';
import { ShopifyCookieKey } from '../constants';

// Looks up, decodes, and splits a Shopify cookie used for registering a Shopify store.
export const useShopifyCookie = () => {
  const { cookieValue } = useCookie(ShopifyCookieKey);
  return useMemo(() => {
    if (!cookieValue) {
      return null;
    }
    const decodedCookie = decodeURIComponent(cookieValue);
    const [tokenPayload, registrationPayload] = decodedCookie.split('|');
    return {
      tokenPayload,
      registrationPayload,
    };
  }, [cookieValue]);
};
